import { defineStore, mapActions } from "pinia";
import { useAxiosStore } from "js/stores/axiosStore.js";

export const useBucketListStore = defineStore("bucketListStore", {
    state: () => {
        return {
            dirty: true,
            query: {},
            list: [],
            index: {},
        };
    },
    actions: {
        populate(list) {
            this.list = list;
            this.dirty = false;
            this.buildIndex();
        },

        find(id) {
            const i = this.index[id];
            if (i === undefined) {
                return null;
            }
            return this.list[i];
        },

        add(bucketList) {
            const currentLength = this.list.push(bucketList);
            this.index[bucketList.id] = currentLength - 1;

            let hasQuery = !!Object.keys(this.query).length;
            if (hasQuery) {
                this.dirty = true;
                this.query = {};
            }
        },

        update(bucketList) {
            this.list[this.index[bucketList.id]] = bucketList;
        },

        updateQuery(key, value) {
            if (value === null && this.query[key]) {
                delete this.query[key];
            } else {
                this.query[key] = value;
            }
        },

        replaceItem(id, itemId, newItem) {
            let bucketList = this.find(id);
            bucketList.items.forEach((item) => {
                if (item.id !== itemId) {
                    return;
                }
                Object.keys(item).forEach((key) => {
                    item[key] = newItem[key];
                });
            });
        },

        remove(id) {
            if (this.index[id] === undefined) {
                return;
            }
            this.list = this.list.filter((bl) => bl.id !== id);
            this.buildIndex();
        },

        buildIndex() {
            this.index = {};
            this.list.forEach((el, i) => {
                this.index[el.id] = i;
            });
        },

        setDirty() {
            this.dirty = true;
        },

        ...mapActions(useAxiosStore, ["fetch", "create", "edit", "delete"]),
    },
});
